import { render, staticRenderFns } from "./PatientContacts.vue?vue&type=template&id=677df573&"
import script from "./PatientContacts.vue?vue&type=script&lang=js&"
export * from "./PatientContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports